var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2832 10.1623L23.2178 0H21.1006L13.3428 8.8239L7.1466 0H0L9.3698 13.3432L0 24H2.1174L10.31 14.6818L16.8536 24H24.0002L14.2832 10.1623ZM11.3832 13.4606L10.4338 12.132L2.8802 1.55953H6.1322L12.2282 10.0918L13.1776 11.4204L21.1016 22.5111H17.8496L11.3832 13.4606Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterWhiteLogo);
export default __webpack_public_path__ + "static/media/twitter-white-logo.c807a6f15489c1e058825440c7e0f9bd.svg";
export { ForwardRef as ReactComponent };